import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { PostData } from '../../services/PostData';
import { GetData } from '../../services/GetData';
import {
	Row,
	Col,
	Button,
	ButtonDropdown,
	DropdownToggle,
	DropdownMenu,
	DropdownItem,
	Card,
	CardHeader,
	CardFooter,
	CardBody,
	Collapse,
	Form,
	FormGroup,
	FormText,
	Label,
	Input,
	InputGroup,
	InputGroupAddon,
	InputGroupText,
	Table,
	Modal, ModalHeader, ModalBody, ModalFooter
} from 'reactstrap';
import $ from 'jquery';
import AcademicPage from '../../views/AcademicPage/';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import LOGO from '../../assets/logo.jpg';
const GLOBAL = require('../../Globals');

const bgRedColor = {backgroundColor : '#ffc4c4'}
const bgColor = {backgroundColor : '#FFF'}

class AnalysisReport extends Component {

	/** set property value **/
	constructor(props) {
		super(props);
		this.state = {
			acyear: '',
			cls: '',
			section: '',
			examname: '',
			subject: '',
			_message: '',
			alertClass: '',
			_redirect: false,
			posts: [],
			accyear: [],
			sections: [],
			exams: [],
			subj: [],
			timetable: [],
			data: [],
			marks: [],
			markdata: [],
			stud: [],
			marktotal: [],
			allocateClass: [],
		}
		this.onChange = this.onChange.bind(this);
	}

	/** set value **/
	onChange(e) {
		this.setState({ [e.target.name]: e.target.value });
		if(e.target.name == 'acyear'){
			this.getexam();
		}
		else if(e.target.name == 'cls'){
			this.getsection();
			this.getsubject();
		}
		else if(e.target.name == 'section'){
			this.getdata();
			this.getstudent();
		}
		else if(e.target.name == 'examname'){
			this.gettimetable();
			this.getmark();
		}
		
	}

	componentWillMount() {

		this.getacyear();
		this.getclass();
	}

	/** get Academic Year **/
	getacyear() {
		$("#showLoader").show();
		GetData('academic/getacyear').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					accyear: responseJson
				});
				var index = responseJson.findIndex(function (obj) {
					return (obj.iscurrent == 1);
				});
				var academic = $("#year").find("option:eq(1)").val();
				this.setState({
					acyear: responseJson[index].id
				});
				$('#year option').eq(index + 1).prop('selected', true).trigger('change');
				
				let userData = JSON.parse(sessionStorage.getItem('userData'));
				this.state.userId = userData['userid'];
				this.state.userRole = userData['userrole'];
				this.state.staffid = userData['staffid'];
				this.setState({
					staffid: userData['staffid']
				});
				this.getexam();
				if(userData['userrole'] == 'classteacher'){
					this.checkclassteacher();
				}
			}
		});
	}
	
	checkclassteacher(){
		$("#showLoader").show();
		GetData('employee/checkclassteacher/'+this.state.acyear+'/'+this.state.staffid).then((result) => {
			let responseJson = result;
			if(responseJson){
				this.setState({
					allocateClass : responseJson
				});
			}
			$("#showLoader").hide();
		});
	}

	getclass() {
		$("#showLoader").show();
		GetData('classs/getclass').then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					posts: responseJson
				});
			}
		});
	}
	
	getsection() {
		$("#showLoader").show();
		var ac = $("#year").val();
		var cls = $("#clas").val();
		GetData('section/getsecbyclass/'+ac+'/'+cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					sections: responseJson
				});
			}
		});
	}

	getexam() {

		var ac = $("#year").val();
		$("#showLoader").show();
		GetData('exam/getexambyacyear/' + ac).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.state.marktotal = [];
				this.setState({
					exams: responseJson
				});
				this.state.marktotal = new Array(this.state.exams.length);
			}
		});
	}

	getsubject() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		$("#showLoader").show();
		GetData('assignsubject/getmainsubbycls/' + ac + '/' + cls).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					subj: responseJson
				});
			}
		});
	}

	getstudent() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		var sec = $("#secs").val();
		$("#showLoader").show();
		GetData('student/getstdbysecandcls/' + ac + '/' + cls + '/' + sec).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					classname : responseJson[0]['cls']+' '+responseJson[0]['sec'],
					stud: responseJson
				});
			}
		});
	}

	getdata() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		var sec = $("#secs").val();
		$("#showLoader").show();
		GetData('student/getstddetails/' + ac + '/' + cls + '/' + sec).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					data: responseJson
				});
			}
		});
	}

	// Get Subject By Class
	getsubjectbycls() {

		var subj = [];

		for (var i = 0; i < this.state.subj.length; i++) {
			subj.push(<th>{this.state.subj[i].prefix}</th>);
		}
		return subj;
	}
	
	getstudcount(type){
		var result = [];
		var d = this.state.markdata;
		var s = this.state.stud.length;
		var t = this.state.timetable;
		var passmark = 0;
		var dat1 = [];
		
		for (var i = 0; i < this.state.subj.length; i++) {
			var sub = this.state.subj[i].subject;
			var dat = d.filter(function(obj){
				return(obj.subject == sub && obj.mark == '-1.00');
			});
			
			var tindex = t.findIndex(function(objt){
				return(objt.subject == sub);
			});
			
			if(tindex > -1){
				passmark = t[tindex]['passmark'];
				
			}
			var dat1 = d.filter(function(obj1){
				if(obj1.mark== '-1.00'){
					
				}
				else{
					return(obj1.subject == sub && parseInt(obj1.mark)< parseInt(passmark));
				}
			});
			var length = dat.length;
			var slength = dat1.length;
			if(type == 'present'){
				result.push(<td align="center">{parseInt(s-length)}</td>);
			}
			else if(type == 'absent'){
				result.push(<td align="center">{parseInt(length)}</td>);
			}
			else if(type == 'pass'){
				result.push(<td align="center">{parseInt(s-length-slength)}</td>);
			}
			else if(type == 'fail'){
				result.push(<td align="center">{parseInt(slength)}</td>);
			}
		}
		return result;
	}
	
	getsubavg(){
		var d = this.state.markdata;
		var mark = 0;
		var result = [];
		var s = this.state.stud.length;
		for (var i = 0; i < this.state.subj.length; i++) {
			var sub = this.state.subj[i].subject;
			var dat = d.filter(function(obj){
				return(obj.subject == sub && obj.mark == '-1.00');
			});
			var length = dat.length;
			var dat = d.filter(function(obj){
				if(obj.subject == sub && obj.mark!='-1.00'){
					mark+=parseFloat(obj.mark);
				}
			});
			
			result.push(<td align="center">{Math.round(parseFloat(mark/parseInt(s-length)))}</td>);
		}
		return result;
	}
	
	getpasspercentage(){
		var d = this.state.markdata;
		var t = this.state.timetable;
		var mark = 0;
		var passmark = 0;
		var result = [];
		var s = this.state.stud.length;
		for (var i = 0; i < this.state.subj.length; i++) {
			var sub = this.state.subj[i].subject;
			var dat = d.filter(function(obj){
				return(obj.subject == sub && obj.mark == '-1.00');
			});
			var tindex = t.findIndex(function(objt){
				return(objt.subject == sub);
			});
			
			if(tindex > -1){
				passmark = t[tindex]['passmark'];
				
			}
			var dat1 = d.filter(function(obj1){
				if(obj1.mark== '-1.00'){
					
				}
				else{
					return(obj1.subject == sub && parseInt(obj1.mark)< parseInt(passmark));
				}
			});
			var length = dat.length;
			var slength = dat1.length;
			var dat = d.filter(function(obj){
				if(obj.subject == sub && obj.mark!='-1.00'){
					mark+=parseFloat(obj.mark);
				}
			});
			
			var plength = parseInt(s-length);
			var passlength = parseInt(plength-slength);
			result.push(<td align="center">{Math.round(parseFloat(passlength/plength)*100)}</td>);
		}
		return result;
	}

	gettimetable() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		var exam = $("#exam").val();
		$("#showLoader").show();
		GetData('exam/gettimetable/' + ac + '/' + cls + '/' + exam).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					timetable: responseJson
				});
			}
		});
	}

	getmark() {

		var ac = $("#year").val();
		var cls = $("#clas").val();
		var sec = $("#secs").val();
		var exam = $("#exam").val();
		$("#showLoader").show();
		this.setState({markdata : []});
		GetData('exam/getmarkbyabserve/' + ac + '/' + cls + '/' + sec + '/' + exam).then((result) => {
			$("#showLoader").hide();
			let responseJson = result;
			if (responseJson) {
				this.setState({
					markdata: responseJson
				});
			}
		});
	}
	
	getmarkbystd(regno, index) {

		var mar = [];
		var tot = 0;
		var total = 0;
		for (var j = 0; j < this.state.subj.length; j++) {
			var sub = this.state.subj[j].subject;
			var mark = this.checkmarks(regno, sub);
			if (mark!= false) {

				mar.push(<td align="center" style={this.checkfail(sub,mark)}>{parseFloat(mark) == '-1' ? 'AB' : parseFloat(mark)}</td>);
				if( parseFloat(mark)!='-1'){
					tot += parseFloat(mark);
				}
				this.state.marktotal[index] = tot;
			}
			else {

				mar.push(<td></td>);
			}
		}

		return mar;
	}
	
	checkfail(sub,mark){
		
		var d = this.state.timetable;
		var result = bgColor;
		var index = d.findIndex(function(obj){
			return(obj.subject == sub);
		});
		if(index > -1){
			
			if(parseInt(mark)!='-1' && parseInt(mark) < parseInt(d[index]['passmark'])){
				result = bgRedColor;
			}
		}
		return result;
	}

	checkmarks(regno, sub) {

		var bstate = false;

		for (var ii = 0; ii < this.state.markdata.length; ii++) {

			if (this.state.markdata[ii].subject == sub && this.state.markdata[ii].studentid == regno) {

				bstate = this.state.markdata[ii].mark;
				break;
			}
			else {

				bstate = false;
			}
		}

		return bstate;

	}
	
	getexamname(){
		var exam = $("#exam").val();
		var d = this.state.exams;
		
		var index = d.findIndex(function(obj){
			return(obj.id == exam);
		});
		if(index > -1){
			return d[index]['exam'];
		}
	}
	
	checkClass(cls){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.class == cls);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
	checkSection(sec){
		var bstate = false;
		var d = this.state.allocateClass;
		var index = d.findIndex(function(obj){
			return(obj.section == sec);
		});
		if(index > -1){
			bstate = true;
		}
		return bstate;
	}
	
	render() {

		if (this.state._redirect) {

			return (<Redirect to={'/subject/subjectupdate/' + this.state.idd} />);

		}

		var exa = this.state.exams;
		var items = this.state.posts;
		var acyear = this.state.accyear;
		var sub = this.state.subj;

		if (this.state.acyear != '' && this.state.cls != '' && this.state.section != '' && this.state.examname != '') {

			$("#abserve").show();
		}
		else {

			$("#abserve").hide();
		}

		return (
			<div>
				<AcademicPage />
				<div className="animated fadeIn">
					<div className={this.state.alertClass}>
						{this.state._message}
					</div>
					<Row>
						<Col md="12">
							<Card>
								<CardHeader>
									<strong>Analysis Report</strong>
									<span style={{float : 'right'}}>
										<ReactHTMLTableToExcel
											id="test-table-xls-button"
											className="download-table-xls-button"
											table="table-to-xls"
											filename="AnalysisReport"
											sheet="tablexls"
											buttonText="Excel" />
									</span>
									<Row>
										<Col md={3} sm={12} xs={12}>
											<label>Academic Year</label>
											<select name="acyear" onChange={this.onChange} className="form-control" required id="year">
												<option value="">Select Academic Year</option>
												{
													acyear.map(function (item) {
														return <option value={item.id}>{item.value}</option>;
													})
												}
											</select>
										</Col>
										<Col md={3} sm={12} xs={12}>
											<label>Class</label>
											<select name="cls" onChange={this.onChange} className="form-control" required id="clas">
												<option value="">Select Class</option>
												{(this.state.userRole == 'classteacher') ?
													items.map((item)=>{
														if(this.checkClass(item.id)){
															return <option value={item.id}>{item.class}</option>;
														}
													})
													:
													items.map(function (item) {
														return <option value={item.id}>{item.class}</option>;
													})
												}
											</select>
										</Col>
										<Col md={3} sm={12} xs={12}>
											<label>Section</label>
											<select name="section" onChange={this.onChange} className="form-control" required id="secs">
												<option value="">Select Section</option>
												{(this.state.userRole == 'classteacher') ?
													this.state.sections.map((item)=>{
														if(this.checkSection(item.section)){
															return <option value={item.section}>{item.secs}</option>;
														}
													})
													:
													this.state.sections.map(function (item) {
														return <option value={item.section}>{item.secs}</option>;
													})
												}
											</select>
										</Col>
										<Col md={3} sm={12} xs={12}>
											<label>Exam</label>
											<select name="examname" onChange={this.onChange} className="form-control" required id="exam">
												<option value="">Select Exam</option>
												{
													exa.map(function (item) {
														return <option value={item.id}>{item.exam}</option>;
													})
												}
											</select>
										</Col>
									</Row>
								</CardHeader>
								<CardBody>
								{this.state.markdata.length > 0 ?
									<Row id="abserve">
										<Col md="12">
											<Table responsive bordered id="table-to-xls">
												<thead>
													<tr>
														<td align="center" colSpan={4+this.state.subj.length}>
															{/*<img src={LOGO} width="90px" />&emsp;&emsp;&emsp;*/}
															<b style={{fontSize : '20px'}}>{GLOBAL.Scl_NAME}</b>
														</td>
													</tr>
													<tr>
														<td align="center" colSpan={4+this.state.subj.length}><b>{this.getexamname()} {this.state.classname}</b></td>
													</tr>
													<tr>
														<th>S.No</th>
														<th>Reg No</th>
														<th>Student Name</th>
														{this.getsubjectbycls()}
														<th>Tot</th>
													</tr>
												</thead>
												<tbody>
													{this.state.stud.map((item, index) =>

														<tr key={item}>
															<td>{index + 1}</td>
															<td>{item.regno}</td>
															<td>{item.stdname}</td>
															{this.getmarkbystd(item.regno, index)}
															<td align="center">{this.state.marktotal[index]}</td>
														</tr>
													)}
													<tr>
														<td colSpan="3" align="center"><b>No.of Students Appeared</b></td>
														{this.getstudcount('present')}
														<td></td>
													</tr>
													<tr>
														<td colSpan="3" align="center"><b>No.of students absent</b></td>
														{this.getstudcount('absent')}
														<td></td>
													</tr>
													<tr>
														<td colSpan="3" align="center"><b>No.of Students Passed</b></td>
														{this.getstudcount('pass')}
														<td></td>
													</tr>
													<tr>
														<td colSpan="3" align="center"><b>No.of Students Failed</b></td>
														{this.getstudcount('fail')}
														<td></td>
													</tr>
													<tr>
														<td colSpan="3" align="center"><b>Subject Avg</b></td>
														{this.getsubavg()}
														<td></td>
													</tr>
													<tr>
														<td colSpan="3" align="center"><b>Pass percentage</b></td>
														{this.getpasspercentage()}
														<td></td>
													</tr>
												</tbody>
											</Table>
										</Col>
									</Row> : ''}
								</CardBody>
							</Card>
						</Col>
					</Row>
				</div>
			</div>
		)
	}
}

export default AnalysisReport;


// WEBPACK FOOTER //
// ./src/exams/Report/AnalysisReport.js